import { Component } from '@angular/core';

@Component({
  selector: 'app-why-top-teams',
  templateUrl: './why-top-teams.component.html',
  styleUrls: ['./why-top-teams.component.css']
})
export class WhyTopTeamsComponent {
  whyFeatures = [
    {
      icon: 'bi-people-fill',
      iconBg: '#FFF3EE',
      iconColor: '#ff7a59',
      title: 'Reach Qualified Candidates',
      desc: 'Distribute your job postings across top networks to find the perfect fit.',
    },
    {
      icon: 'bi-grid-fill',
      iconBg: '#FFF3EE',
      iconColor: '#ff7a59',
      title: 'Manage Everything in One Platform',
      desc: 'Centralize your hiring process from posting to final offer.',
    },
    {
      icon: 'bi-speedometer2',
      iconBg: '#FFF3EE',
      iconColor: '#ff7a59',
      title: 'Move Faster Through Hiring',
      desc: 'Automate repetitive tasks and accelerate your time-to-hire.',
    },
    {
      icon: 'bi-sliders',
      iconBg: '#FFF3EE',
      iconColor: '#ff7a59',
      title: 'Flexible Hiring Workflow',
      desc: 'Comprehensive post-interview analytics give you the data needed to make confident hiring choices.',
    },
  ];
}
